import Button from 'components/Button'
import { FilterText } from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { StyledTable } from 'components/TableStyles/TableStyles'
import CompanyInfo from 'modules/Dashboard/Partials/DrivesInfoTable/Partials/CompanyInfo'
import {
  ModeText,
  NavWrapper,
  StyledP,
  TableTop,
} from 'modules/Drive/Partials/DrivesInfoTable/Style/style'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const Index = ({
  dashboardDriveList,
  drivesList = [],
  onDrawerInfoChanged,
  setUrl,
  currentUrl,
  setCurrentPage,
  currentPage,
  count = 1,
  onSortValueChanged,
  loading = false,
  setSearch,
  sortBy,
  setSortBy,
  orderBy,
  setOrderBy,
  selectionType,
}) => {
  const navigate = useNavigate()

  const delaySaveToDb = useCallback(
    debounce(text => {
      setCurrentPage(1)
      setSearch(text)
      setSortBy('')
      setOrderBy('asc')
    }, 1000),
    []
  )
  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }
  const sortFilter = sort => {
    let sortOrder = ''
    if (sort == sortBy) {
      sortOrder = orderBy == 'asc' ? 'desc' : 'asc'
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
  }

  const columns = [
    {
      title: 'Company Details',
      dataIndex: '',
      sorter: true,
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('name')
          },
        }
      },
      key: 'name',
      width: '25%',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => <CompanyInfo data={data} />,
    },
    {
      title: 'Roles Floated',
      dataIndex: 'rolesFloated',
      key: 'rolesFloated',

      render: (text, item) => <ModeText>{text}</ModeText>,
    },
    {
      title: 'Tot. Candidate Applied',
      dataIndex: 'appliedStudent',
      key: 'appliedStudent',
      render: (text, item) => <StyledP>{text}</StyledP>,
    },
    {
      title: 'Tot. Candidate Hired',
      dataIndex: 'hiredCandidateCount',
      key: 'hiredCandidateCount',
      render: (text, item) => <StyledP>{text}</StyledP>,
    },

    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (text, item) => (
        <Button.Secondary
          text="View"
          onClick={() => {
            actionClicked(item)
          }}
        />
      ),
    },
  ]
  const actionClicked = data => {
    navigate(`/dashboard/roles/${data?.id}?occurrence=${selectionType}`)
  }
  return (
    <NavWrapper column>
      <TableTop row spaceBetween alignCenter>
        <SearchInput
          width={'25%'}
          placeholder="Search by company name"
          bordered={false}
          setSearchValue={text => {
            delaySaveToDb(text)
          }}
        />

        <FilterText>
          Showing{' '}
          {10 * (currentPage - 1) + dashboardDriveList?.corporateData?.length}{' '}
          of {dashboardDriveList?.count}
        </FilterText>
      </TableTop>
      <StyledTable
        columns={columns}
        loading={loading}
        dataSource={dashboardDriveList?.corporateData}
        pagination={{
          showSizeChanger: false,
          defaultPageSize: 10,
          current: currentPage,
          onChange: (page, pageSize) => {
            paginationChange(page, pageSize)
          },
          total: dashboardDriveList?.count,
        }}
      />
    </NavWrapper>
  )
}

export default Index
